import React from 'react';
import styled from 'styled-components';
import Utility from '../../../../../../../../util/utilityfunctions';
import {labels} from '../../../../../../../../util/utils';
import {ShowMore} from '@ey/canvascoreservices';

function AGGridRichTextCellRenderer({value, data, column}) {
	if (typeof value === 'string') {
		return (
			<StyledAGGridRichTextCellRenderer className={column.colId !== 'description' && data.className}>
				<ShowMore
					noOfLines={10}
					labels={{showMore: labels.showMore, showLess: labels.showLess}}
					handleBreaks
					tolerance={1}
				>
					{Utility.createRichTextElement(value)}
				</ShowMore>
			</StyledAGGridRichTextCellRenderer>
		);
	}

	return null;
}

export default AGGridRichTextCellRenderer;

const StyledAGGridRichTextCellRenderer = styled.section`
	display: flex;
	font-size: var(--px-14);
	font-weight: 300;
	line-height: var(--px-16);
	color: var(--neutrals-900);

	&.no-answer-provided {
		color: var(--neutrals-900);
		font-weight: 300;
		font-style: italic;
	}

	.richText-Body {
		white-space: unset !important;
		&.collapsed {
			max-height: var(--px-160) !important;
		}
	}

	.show-more-controls {
		button {
			color: var(--blue-600);
		}
	}

	.createRichTextElementSpanWrapper {
		text-wrap: wrap;
		font-size: var(--px-14);
		line-height: var(--px-16);
		* {
			font-size: var(--px-14);
			line-height: var(--px-16);
			font-weight: 300;
			color: var(--neutrals-900);
		}
		& > p {
			font-size: var(--px-14);
			margin: 0;
		}
		ul {
			padding: 0;
			li {
				list-style: disc;
				margin-left: var(--px-30);
				margin-bottom: var(--px-0);
				font-weight: 500;
				p {
					margin: 0;
				}
			}
		}
		ol {
			padding: 0;
			li {
				list-style: inherit;
				font-weight: 500;
			}
		}
	}
`;
